<template>
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore @赵缙翔 volar bug -->
        <path
            d="M17.629 10.972a.889.889 0 0 1 0 1.257l-3.772 3.77 3.772 3.772a.889.889 0 1 1-1.258 1.257l-4.4-4.4a.889.889 0 0 1 0-1.257l4.4-4.4a.889.889 0 0 1 1.258 0z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
